import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import UserImpersonate from './UserImpersonate';
import { Link } from 'react-router-dom';
import { canImpersonate, canManageUsers } from "../../PermissionSelectors";
import { connect } from "react-redux";
import Pagination from "../navigation/Pagination";

function formatColumn(cell, row) {
    if (row) {
        return (`${'<div class="truncate"><span>'}${row.Company}${'</span></div>'}`);
    }
}

function formatEmailColumn(cell, row) {
    if (row) {
        return (`${'<div class="truncate"><span>'}${row.Email}${'</span></div>'}`);
    }
}




function impersonateFormatter(cell, row) {   // String example
    return <UserImpersonate user={row} />;
};

function formatStatusColumn(cell,row) {
    if (row.Status === 'active') {
        return (<span className="status-green">{row.Status}</span>);
    }
    return (<span className="status-red">{row.Status}</span>);
}
function nameColumn(cell, row) {
    if (row.FirstName || row.LastName) {
        return (`${'<div class="truncate"><span>'}${row.FirstName} ${row.LastName}${'</span></div>'}`);
    }
}
function profileColumn(cell, row) {
    let display = "";
    if (row.PrimaryAccountTypeId === 1) {
        display = "Sold To";
    } else if (row.PrimaryAccountTypeId === 2) {
        display = "Payer";
    } else if (row.PrimaryAccountTypeId === 3) {
        display = "Payer - All";
    }
    return (`${'<div class="truncate"><span>'}${display}${'</span></div>'}`);
}
function accountsColumn(cell, row) {
    let accountNumbers = [];
   
    if (row.Accounts != undefined)
        row.Accounts.forEach((a) => accountNumbers.push(a.PrimaryAcct));
    if (accountNumbers.length > 0) {
        return (`${'<div class="truncate"><span>'}${accountNumbers.join(", ")}${'</span></div>'}`);
    }
}

class UserList extends Component {

    constructor(props) {
        super(props);
        this.userName = this.userName.bind(this);
    }


    userName(cell, row) {
        if (row) {
            if (this.props.canManageUsers) {
                return <Link to={`/settings/users/${row.UserId}`}>{row.Login}</Link>;
            } else {
                return cell;
            }
        }
    }

    render() {
        return (
            <div>
                <BootstrapTable data={this.props.users} tableHeaderClass="user-list-table-header"
                    tableContainerClass={'wa-bootstrap-table-container'}
                    tableBodyClass='wa-bootstrap-small-text'>
                    {this.props.canImpersonate &&
                        <TableHeaderColumn width="50" className="headerColumnColor" dataAlign="center" dataField="login"
                            dataFormat={impersonateFormatter}>
                            Impersonate
                        </TableHeaderColumn>}
                    <TableHeaderColumn width="65" className="headerColumnColor" dataAlign="center" dataField="login"
                        dataFormat={this.userName} isKey>
                        User Id
                    </TableHeaderColumn>
                    <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center"
                        dataFormat={nameColumn}>
                        Name
                    </TableHeaderColumn>
                    <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center" dataField="company"
                        dataFormat={formatColumn}>
                        Company
                    </TableHeaderColumn>
                    <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center" dataField="email"
                        dataFormat={formatEmailColumn}>
                        eMail
                    </TableHeaderColumn>
                    <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center" dataField="status"
                        dataFormat={formatStatusColumn}>
                        Status
                    </TableHeaderColumn>
                    <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center"
                        dataFormat={profileColumn}>
                        Profile
                    </TableHeaderColumn>
                    <TableHeaderColumn width="55" className="headerColumnColor" dataAlign="center" dataField="accounts"
                        dataFormat={accountsColumn}>
                        Accounts
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}

UserList.propTypes = {
    users: PropTypes.array.isRequired,
};

export default connect((state, props) => ({
    canManageUsers: canManageUsers(state, props),
    canImpersonate: canImpersonate(state, props)
}))(UserList);
